import React, { Component } from 'react'
import { Drawer } from 'vaul'
import Select from "react-select";

import {
  algorithmTypeOptions,
  animationIntervalOptions,
  heuristicOptions,
  movementStyleOptions
} from "../algorithms/options";
import Tooltip from "./tooltip";

const LARGE_SCREEN_SNAP_POINTS = ["100px"];
const SMALL_SCREEN_SNAP_POINTS = ["100px", "254px"];

// thresholds for what counts as a “tap”
const MOVE_THRESHOLD = 10;    // pixels
const TIME_THRESHOLD = 500;   // milliseconds

class ControlPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      snap: '100px',
    };
    this._tap = { x: 0, y: 0, t: 0 }; // used to avoid jank when using vaul
  }

  // record start coords & time
  handlePointerDown = (e) => {
    this._tap.x = e.clientX;
    this._tap.y = e.clientY;
    this._tap.t = Date.now();
  }

  // compare end coords/time; fire handler if within thresholds
  handlePointerUp = (e, handler) => {
    const dx = e.clientX - this._tap.x;
    const dy = e.clientY - this._tap.y;
    const dt = Date.now() - this._tap.t;
    if (Math.hypot(dx, dy) <= MOVE_THRESHOLD && dt <= TIME_THRESHOLD) {
      handler(e);
    }
    this.handlePointerCancel();  // reset
  }

  // clear the stored tap data
  handlePointerCancel = () => {
    this._tap.x = 0;
    this._tap.y = 0;
    this._tap.t = 0;
  }


  render() {
    const {
      isAnimating,
      handlers: {
        clearGrid,
        visualizeAlgo,
        stopAnimation,
        handleIntervalChange,
        handleAlgorithmChange,
        handleHeuristicChange,
        handleMovementStyleChange,
        addRandomObstacles,
        genMazeBinaryTree,
        genMazeRandomPrims,
      },
      selectValues: {
        animationInterval,
        algorithmType,
        heuristic,
        movementStyle,
      },
    } = this.props;

    const snapPoints = window.innerWidth >= 768
      ? LARGE_SCREEN_SNAP_POINTS
      : SMALL_SCREEN_SNAP_POINTS;

    const mainHandler = isAnimating ? stopAnimation : visualizeAlgo;

    return (
      <Drawer.Root
        snapPoints={snapPoints}
        activeSnapPoint={this.state.snap}
        setActiveSnapPoint={(snapPoint) => this.setState({snap: snapPoint})}
        dismissible={false}
        defaultOpen={true}
        modal={false}
      >
      {/* <Drawer.Overlay className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50" /> */}
      <Drawer.Portal>
        <Drawer.Content asChild>
        <div className="control-panel h-100">
        {/* NOTE: only Including drawer title to avoid radixUI warnings/errors */}
        <Drawer.Title className="d-none">Control Panel</Drawer.Title>
        <Drawer.Description className="d-none">Control visualzier parameters.</Drawer.Description>
        <div className="container-fluid control-panel-content">
          <div className="row h-md-100">
            <div className="col-md-2 h-100 order-3 order-md-1 px-0 d-flex">
              <button
                className="btn btn-lg w-100 h-100 btn-secondary rounded-0"
                disabled={isAnimating}
                onClick={clearGrid}
              >
                Clear grid
              </button>
            </div>

            <div className="col-md-8 h-100 order-2 order-md-2">
              <div className="d-flex flex-wrap pt-md-2 pb-1 justify-content-center gap-2">
                <div style={{ width: "9em" }}>
                  <Select
                    defaultValue={animationInterval}
                    onChange={handleIntervalChange}
                    options={animationIntervalOptions}
                    isSearchable={false}
                    menuPlacement="auto"
                    classNamePrefix="rounded-0 "
                    isDisabled={isAnimating}
                  />
                </div>
                <div style={{ width: "9em" }}>
                  <Select
                    defaultValue={algorithmType}
                    onChange={handleAlgorithmChange}
                    options={algorithmTypeOptions}
                    isSearchable={false}
                    menuPlacement="auto"
                    classNamePrefix="rounded-0 "
                    isDisabled={isAnimating}
                  />
                </div>
                <div style={{ width: "9em" }}>
                  <Select
                    defaultValue={heuristic}
                    onChange={handleHeuristicChange}
                    options={heuristicOptions}
                    isSearchable={false}
                    menuPlacement="auto"
                    classNamePrefix="rounded-0 "
                    isDisabled={isAnimating}
                  />
                </div>
                <div style={{ width: "9em" }}>
                  <Select
                    defaultValue={movementStyle}
                    onChange={handleMovementStyleChange}
                    options={movementStyleOptions}
                    isSearchable={false}
                    menuPlacement="auto"
                    classNamePrefix="rounded-0 "
                    isDisabled={isAnimating}
                  />
                </div>
              </div>
              <div className="d-flex pt-1 pb-2 justify-content-center">
                <Tooltip text="Add random obstacles">
                  <button
                    className="btn btn-warning rounded-0 mx-1 d-flex align-items-center justify-content-center"
                    style={{ height: 36, width: 36 }}
                    disabled={isAnimating}
                    onClick={addRandomObstacles}
                  >
                    <img src="icons/random.svg" alt="random icon" />
                  </button>
                </Tooltip>
                <Tooltip text="Generate binary tree maze">
                  <button
                    className="btn btn-danger rounded-0 mx-1 d-flex align-items-center justify-content-center"
                    style={{ height: 36, width: 36 }}
                    disabled={isAnimating}
                    onClick={genMazeBinaryTree}
                  >
                    <img src="icons/maze_binary_tree.svg" alt="maze icon" />
                  </button>
                </Tooltip>
                <Tooltip text="Generate prims maze">
                  <button
                    className="btn btn-danger rounded-0 mx-1 d-flex align-items-center justify-content-center"
                    style={{ height: 36, width: 36 }}
                    disabled={isAnimating}
                    onClick={genMazeRandomPrims}
                  >
                    <img src="icons/maze_prims.svg" alt="maze icon" />
                  </button>
                </Tooltip>
              </div>
            </div>
            <div className="col-md-2 order-1 order-md-3 h-50 h-md-100 px-0 d-flex flex-column">
              <button
                className="btn btn-lg w-100 h-100 btn-primary btn-glow rounded-0"
                style={{ position: "relative" }}
                // NOTE: the following pointer events are used instead of onClick to avoid vaul jank
                onPointerDown={this.handlePointerDown}
                onPointerUp={e => this.handlePointerUp(e, mainHandler)}
                onPointerCancel={this.handlePointerCancel}
              >
                {isAnimating ? "Cancel" : "Visualize"}
              </button>
              <div className="w-100 text-center text-secondary d-md-none" style={{height: 24}}>
                {this.state.snap === snapPoints?.[1] ? "Swipe down to hide controls" : "Swipe up to show all controls"}
              </div>
            </div>
          </div>
        </div>
      </div>

        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>

    );
  }
}

export default ControlPanel;
